import { render } from "./BarangKeluar.vue?vue&type=template&id=8b18c7cc&scoped=true"
import script from "./BarangKeluar.vue?vue&type=script&lang=js"
export * from "./BarangKeluar.vue?vue&type=script&lang=js"

import "./BarangKeluar.vue?vue&type=style&index=0&id=8b18c7cc&scoped=true&lang=css"
import "./BarangKeluar.vue?vue&type=style&index=1&id=8b18c7cc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\INVENTORY BCK\\inventoryfe_bck\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b18c7cc"]])

export default __exports__